import { DEFAULT_LOCALE } from '#/i18n/locales.js'
import { WEB_LABELS } from './labels.gen.js'

// The Mini App's string table is GENERATED from the bot's Fluent locales (scripts/gen-web-labels.mjs):
// the .ftl is the SINGLE source of wording for both the bot and the web — no more hand-kept second copy.
// This thin runtime just picks the active language's map. The whole product is GROUP-language, so main.ts
// calls setLang(settings.language) after each load/save and every t() call site stays language-agnostic
// (no per-call threading). Everything is fail-soft — a missing language or key never throws; the fallback
// is DEFAULT_LOCALE (the product default — #/i18n/locales is PURE, so the browser bundle can share it).

const FALLBACK_LANG: string = DEFAULT_LOCALE
let activeLang = FALLBACK_LANG

/** The locales the bundle ships (derived from the generated maps = the .ftl files). Drives the selector. */
export const WEB_LOCALES: readonly string[] = Object.keys(WEB_LABELS)

/** Set the active UI language to the group's settings.language. An unsupported value falls back to the product default. */
export function setLang(lang: string): void {
  activeLang = Object.prototype.hasOwnProperty.call(WEB_LABELS, lang) ? lang : FALLBACK_LANG
}

/** The active language code (help.ts resolves the guide prose with it). */
export function getLang(): string {
  return activeLang
}

/**
 * Resolve a label/UI key in the ACTIVE language. Fail-soft chain: active map → the default locale → the
 * literal key (never throws) — mirroring the bot's i18n, where a missing key renders as the key string.
 */
export function t(key: string): string {
  return WEB_LABELS[activeLang]?.[key] ?? WEB_LABELS[FALLBACK_LANG]?.[key] ?? key
}
